/**
 * kit-builder.js
 * -----------------------------------------------------------------
 * Lógica de "Arma tu Kit Personalizado".
 *
 * A diferencia de custom-product-options.js (que personaliza UN solo
 * producto), aquí cada "pieza" que la clienta arma corresponde a un
 * PRODUCTO REAL distinto de la tienda (con su propia variante de
 * talla/color). Por eso, al agregar el kit al carrito, se hace una
 * llamada a /cart/add.js POR CADA PIEZA (más una llamada extra por
 * pieza si esa pieza tiene recargo por mascotas/humano), en vez de
 * agregar un solo producto con propiedades.
 *
 * CONFIGURACIÓN OBLIGATORIA:
 *  PIECE_TYPES define, para cada tipo de pieza y estilo, el producto
 *  real al que corresponde, su precio base, el precio por mascota
 *  extra, si acepta "incluir humano", y el mapa de variantes por
 *  talla/color (cuando aplica). Si agregas un producto nuevo al kit,
 *  actualiza este objeto.
 *
 *  ADDON_VARIANT_MAP (igual que en custom-product-options.js) mapea
 *  montos de recargo a la variante del producto "Cargo adicional".
 */

(function () {
  'use strict';

  var MIN_PIECES = 2;
  var MAX_PIECES = 5;

  // ------------------------------------------------------------------
  // Catálogo de piezas disponibles para el kit.
  // ------------------------------------------------------------------
  var PIECE_TYPES = {
    playera: {
      label: 'Playera',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 10451299303711,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/playera_personalizada_ilustrada_perritos_2d03c5d6-834a-4ead-9dfc-f13c1b377c50.png?v=1772735614',
          basePrice: 1030,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          sizes: ['CH', 'M', 'L', 'XL'],
          colors: ['Beige', 'Blanco', 'Gris Jaspe', 'Negro', 'Rosa Pastel'],
          variantKeyOrder: 'size-color',
          variants: {
            'CH / Beige': 52041175105823, 'CH / Blanco': 52041175138591, 'CH / Gris Jaspe': 52041175367967, 'CH / Negro': 52041591193887, 'CH / Rosa Pastel': 52041591226655,
            'M / Beige': 52041175171359, 'M / Blanco': 52041175204127, 'M / Gris Jaspe': 52041175400735, 'M / Negro': 52041591259423, 'M / Rosa Pastel': 52041591292191,
            'L / Beige': 52041175236895, 'L / Blanco': 52041175269663, 'L / Gris Jaspe': 52041175433503, 'L / Negro': 52041591324959, 'L / Rosa Pastel': 52041591357727,
            'XL / Beige': 52041175302431, 'XL / Blanco': 52041175335199, 'XL / Gris Jaspe': 52041175466271, 'XL / Negro': 52041591390495, 'XL / Rosa Pastel': 52041591423263
          }
        },
        bordado: {
          label: 'Bordado',
          productId: 10589625024799,
          image: null,
          basePrice: 1800,
          pricePerExtraPet: 475,
          humanEnabled: false,
          sizes: ['CH', 'M', 'L', 'XL'],
          colors: ['Beige', 'Blanco', 'Gris Jaspe', 'Negro', 'Rosa Pastel'],
          variantKeyOrder: 'size-color',
          variants: {
            'CH / Beige': 52821022310687, 'CH / Blanco': 52821022343455, 'CH / Gris Jaspe': 52821022376223, 'CH / Negro': 52821022408991, 'CH / Rosa Pastel': 52821022441759,
            'M / Beige': 52821022474527, 'M / Blanco': 52821022507295, 'M / Gris Jaspe': 52821022540063, 'M / Negro': 52821022572831, 'M / Rosa Pastel': 52821022605599,
            'L / Beige': 52821022638367, 'L / Blanco': 52821022671135, 'L / Gris Jaspe': 52821022703903, 'L / Negro': 52821022736671, 'L / Rosa Pastel': 52821022769439,
            'XL / Beige': 52821022802207, 'XL / Blanco': 52821022834975, 'XL / Gris Jaspe': 52821022867743, 'XL / Negro': 52821022900511, 'XL / Rosa Pastel': 52821022933279
          }
        }
      }
    },
    sudadera: {
      label: 'Sudadera',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 10038707618079,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/Sudadera_personalizada_peludito_colori.jpg?v=1737253697',
          basePrice: 1980,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          colors: ['Negro', 'Blanco', 'Café', 'Beige', 'Gris', 'Verde Botella', 'Rosa Pastel', 'Azul Pastel', 'Verde pastel', 'Lila'],
          sizes: ['CH', 'M', 'L', 'XL'],
          variantKeyOrder: 'color-size',
          variants: {
            'Negro / CH': 50517742911775, 'Negro / M': 50517742944543, 'Negro / L': 50517742977311, 'Negro / XL': 50517743010079,
            'Blanco / CH': 50517743042847, 'Blanco / M': 50517743075615, 'Blanco / L': 50517743108383, 'Blanco / XL': 50517743141151,
            'Café / CH': 50517743173919, 'Café / M': 50517743206687, 'Café / L': 50517743239455, 'Café / XL': 50517743272223,
            'Beige / CH': 50517743304991, 'Beige / M': 50517743337759, 'Beige / L': 50517743370527, 'Beige / XL': 50517743403295,
            'Gris / CH': 50517743436063, 'Gris / M': 50517743468831, 'Gris / L': 50517743501599, 'Gris / XL': 50517743534367,
            'Verde Botella / CH': 51094095560991, 'Verde Botella / M': 51094095593759, 'Verde Botella / L': 51094095626527, 'Verde Botella / XL': 51094095659295,
            'Rosa Pastel / CH': 51094095692063, 'Rosa Pastel / M': 51094095724831, 'Rosa Pastel / L': 51094095757599, 'Rosa Pastel / XL': 51094095790367,
            'Azul Pastel / CH': 51094095823135, 'Azul Pastel / M': 51094095855903, 'Azul Pastel / L': 51094095888671, 'Azul Pastel / XL': 51094095921439,
            'Verde pastel / CH': 51094095954207, 'Verde pastel / M': 51094095986975, 'Verde pastel / L': 51094096019743, 'Verde pastel / XL': 51094096052511,
            'Lila / CH': 51094096085279, 'Lila / M': 51094096118047, 'Lila / L': 51094096150815, 'Lila / XL': 51094096183583
          }
        },
        bordado: {
          label: 'Bordado',
          productId: 10274931802399,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/sudadera_azul_colori_bordada_personalizada_mascotas_2.png?v=1771956026',
          basePrice: 2399,
          pricePerExtraPet: 475,
          humanEnabled: false,
          colors: ['Negro', 'Blanco', 'Café', 'Beige', 'Verde Botella', 'Gris', 'Rosa Pastel', 'Lila', 'Verde pastel', 'Azul Pastel'],
          sizes: ['CH', 'M', 'L', 'XL'],
          variantKeyOrder: 'color-size',
          variants: {
            'Negro / CH': 51303245283615, 'Negro / M': 51303245316383, 'Negro / L': 51303245349151, 'Negro / XL': 51303245381919,
            'Blanco / CH': 51303245414687, 'Blanco / M': 51303245447455, 'Blanco / L': 51303245480223, 'Blanco / XL': 51303245512991,
            'Café / CH': 51303245545759, 'Café / M': 51303245578527, 'Café / L': 51303245611295, 'Café / XL': 51303245644063,
            'Beige / CH': 51303245676831, 'Beige / M': 51303245709599, 'Beige / L': 51303245742367, 'Beige / XL': 51303245775135,
            'Verde Botella / CH': 51303245807903, 'Verde Botella / M': 51303245840671, 'Verde Botella / L': 51303245873439, 'Verde Botella / XL': 51303245906207,
            'Gris / CH': 51303245938975, 'Gris / M': 51303245971743, 'Gris / L': 51303246004511, 'Gris / XL': 51303246037279,
            'Rosa Pastel / CH': 51303246070047, 'Rosa Pastel / M': 51303246102815, 'Rosa Pastel / L': 51303246135583, 'Rosa Pastel / XL': 51303246168351,
            'Lila / CH': 51303246201119, 'Lila / M': 51303246233887, 'Lila / L': 51303246266655, 'Lila / XL': 51303246299423,
            'Verde pastel / CH': 51303246332191, 'Verde pastel / M': 51303246364959, 'Verde pastel / L': 51303246397727, 'Verde pastel / XL': 51303246430495,
            'Azul Pastel / CH': 51303246463263, 'Azul Pastel / M': 51303246496031, 'Azul Pastel / L': 51303246528799, 'Azul Pastel / XL': 51303246561567
          }
        }
      }
    },
    tote_bag: {
      label: 'Tote Bag',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 10093418610975,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/ToteBag_chihuahua_ilustrada-2.jpg?v=1741384530',
          basePrice: 1655,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          variants: { 'Default Title': 50709971075359 }
        },
        bordado: {
          label: 'Bordado',
          productId: 10213123621151,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/4C20CF55-2863-4BB9-8B22-C0998C8AB077.jpg?v=1754182670',
          basePrice: 2070,
          pricePerExtraPet: 475,
          humanEnabled: false,
          variants: { 'Default Title': 51092553728287 }
        }
      }
    },
    gorra: {
      label: 'Gorra',
      styles: {
        bordado: {
          label: 'Bordado',
          productId: 10213105697055,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/CB427F7D-CC93-4432-B985-4652BAFE04BC.png?v=1754182806',
          basePrice: 1960,
          pricePerExtraPet: 475,
          humanEnabled: false,
          variants: { 'Default Title': 51092476330271 },
          capColors: [
            { name: 'Beige', hex: '#e3d3ac' },
            { name: 'Azul', hex: '#3457a6' },
            { name: 'Rosa', hex: '#f4c2d7' },
            { name: 'Marino', hex: '#14173a' },
            { name: 'Negro', hex: '#111111' }
          ]
        }
      }
    },
    taza: {
      label: 'Taza',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 9559276257567,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/Tazas_personalizadas_Colori.jpg?v=1736040655',
          basePrice: 1299,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          variants: { 'Default Title': 49997858046239 }
        }
      }
    },
    vaso: {
      label: 'Vaso',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 9559263510815,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/IMG_1668_00041.jpg?v=1736284960',
          basePrice: 1125,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          variants: { 'Default Title': 50000942629151 }
        }
      }
    },
    stickers: {
      label: 'Stickers',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 9480411283743,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/Stickers_copy.jpg?v=1736041788',
          basePrice: 850,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          variants: { 'Default Title': 49997857161503 }
        }
      }
    },
    libreta: {
      label: 'Libreta',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 9458889228575,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/Frente.jpg?v=1754181102',
          basePrice: 1055,
          pricePerExtraPet: 375,
          humanEnabled: true,
          humanPrice: 375,
          variants: { 'Default Title': 49997848215839 }
        }
      }
    },
    print: {
      label: 'Print Ilustrado',
      styles: {
        ilustrado: {
          label: 'Ilustrado',
          productId: 10572590907679,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/IMG_8025.jpg?v=1786493549',
          basePrice: 720,
          pricePerExtraPet: 200,
          humanEnabled: false,
          frameColors: [
            { name: 'Negro', hex: '#111111' },
            { name: 'Blanco', hex: '#ffffff' }
          ],
          variants: { 'Default Title': 52770215985439 }
        },
        bordado: {
          label: 'Bordado',
          productId: 10213126045983,
          image: 'https://cdn.shopify.com/s/files/1/0891/8525/5711/files/E393EE80-0E74-4C57-96B6-CBEB19293FCF.jpg?v=1754182670',
          basePrice: 2050,
          pricePerExtraPet: 475,
          humanEnabled: false,
          frameColors: [
            { name: 'Negro', hex: '#111111' },
            { name: 'Blanco', hex: '#ffffff' }
          ],
          variants: { 'Default Title': 51092564017439 }
        }
      }
    }
  };

  // Estilos disponibles a nivel global (se eligen ANTES que el tipo de
  // producto) y el mapa inverso estilo -> tipos de producto que existen
  // en ese estilo, calculado a partir de PIECE_TYPES.
  var STYLE_OPTIONS = [
    { key: 'ilustrado', label: 'Ilustrado' },
    { key: 'bordado', label: 'Bordado' }
  ];

  var STYLE_TO_TYPES = {};
  Object.keys(PIECE_TYPES).forEach(function (typeKey) {
    var type = PIECE_TYPES[typeKey];
    Object.keys(type.styles).forEach(function (styleKey) {
      if (!STYLE_TO_TYPES[styleKey]) STYLE_TO_TYPES[styleKey] = [];
      STYLE_TO_TYPES[styleKey].push(typeKey);
    });
  });

  // Colores aproximados (solo para mostrar la muestra circular) de cada
  // nombre de color usado en Playera/Sudadera. Si Sarah quiere un tono
  // más exacto, solo hay que ajustar el hex aquí.
  var COLOR_HEX_MAP = {
    Beige: '#e3d3ac',
    Blanco: '#ffffff',
    'Gris Jaspe': '#b0b0b0',
    Negro: '#111111',
    'Rosa Pastel': '#f4c2d7',
    Café: '#6b4a3a',
    Gris: '#8c8c8c',
    'Verde Botella': '#1f4d3a',
    'Azul Pastel': '#a9c9e8',
    'Verde pastel': '#b6e2c6',
    Lila: '#c9b8e8'
  };

  // Igual mapa que custom-product-options.js: montos de recargo -> variante
  // del producto "Cargo adicional". Todos los montos posibles del kit
  // (hasta 5 mascotas extra a $375 o $475, con o sin humano a $375) ya
  // están cubiertos por este mismo mapa.
  var ADDON_VARIANT_MAP = {
    25: 52810860167455,
    50: 52810860200223,
    80: 52810860232991,
    100: 52810860265759,
    150: 52810860298527,
    200: 52810860331295,
    250: 52810860364063,
    300: 52810860396831,
    375: 52810870325535,
    475: 52810887332127,
    750: 52810887364895,
    950: 52810887397663,
    1125: 52810887430431,
    1425: 52810887463199,
    1500: 52810887495967,
    1875: 52810887528735,
    1900: 52810887561503,
    2250: 52810887594271,
    2375: 52810887627039,
    400: 52811793662239,
    575: 52811793695007,
    600: 52811793727775,
    775: 52811793760543,
    800: 52811793793311,
    975: 52811793826079,
    1000: 52811793858847,
    1175: 52811793891615,
    1375: 52811793924383
  };

  var AFTER_ADD_BEHAVIOR = 'redirect';

  // ------------------------------------------------------------------
  // Formato de moneda (idéntico a custom-product-options.js).
  // ------------------------------------------------------------------
  function formatWithDelimiters(amount, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;
    if (isNaN(amount) || amount === null) return '0';
    var fixed = Math.abs(amount).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return (amount < 0 ? '-' : '') + dollars + cents;
  }

  function formatMoney(amount, moneyFormat) {
    try {
      var format = moneyFormat || '${{amount}}';
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!match) return '$' + amount.toFixed(2);
      var value;
      switch (match[1]) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(amount, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(amount, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(amount, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(amount, 2);
      }
      return format.replace(match[0], value);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  // ------------------------------------------------------------------
  // Helpers de lectura de una "pieza" (tarjeta) del kit.
  // ------------------------------------------------------------------
  function getSelectedStyleKey(pieceEl) {
    var selectedPill = pieceEl.querySelector('[data-kit-style-pill].is-selected');
    return selectedPill ? selectedPill.getAttribute('data-value') : STYLE_OPTIONS[0].key;
  }

  function getPieceTypeStyle(pieceEl) {
    var typeKey = pieceEl.querySelector('[data-kit-type]').value;
    var styleKey = getSelectedStyleKey(pieceEl);
    var type = PIECE_TYPES[typeKey];
    if (!type) return null;
    var style = type.styles[styleKey];
    if (!style) return null;
    return { typeKey: typeKey, styleKey: styleKey, type: type, style: style };
  }

  function getPetQty(pieceEl) {
    var selected = pieceEl.querySelector('[data-kit-pet-qty-pill].is-selected');
    return selected ? parseInt(selected.getAttribute('data-value'), 10) || 1 : 1;
  }

  function computePieceSubtotal(pieceEl) {
    var ts = getPieceTypeStyle(pieceEl);
    if (!ts) return 0;
    var petGroup = pieceEl.querySelector('[data-kit-pet-group]');
    var petQty = petGroup && !petGroup.hidden ? getPetQty(pieceEl) : 1;
    var extraPets = petQty - 1;
    var total = ts.style.basePrice + extraPets * ts.style.pricePerExtraPet;

    var humanCheckbox = pieceEl.querySelector('[data-kit-human-checkbox]');
    if (ts.style.humanEnabled && humanCheckbox && humanCheckbox.checked) {
      total += ts.style.humanPrice || 0;
    }
    return total;
  }

  function recalcTotal(root) {
    var total = 0;
    root.querySelectorAll('[data-kit-piece]').forEach(function (pieceEl) {
      var subtotal = computePieceSubtotal(pieceEl);
      total += subtotal;
      var subtotalEl = pieceEl.querySelector('[data-kit-piece-subtotal]');
      var moneyFormat = root.getAttribute('data-money-format');
      if (subtotalEl) {
        subtotalEl.textContent = 'Precio de esta pieza: ' + formatMoney(subtotal, moneyFormat);
      }
    });
    var totalEl = root.querySelector('[data-kit-total]');
    if (totalEl) {
      totalEl.textContent = formatMoney(total, root.getAttribute('data-money-format'));
    }
  }

  // ------------------------------------------------------------------
  // Bloques de mascota (idéntico patrón a custom-product-options.js).
  // ------------------------------------------------------------------
  function updatePetBlocksVisibility(pieceEl) {
    var qty = getPetQty(pieceEl);
    pieceEl.querySelectorAll('[data-kit-pet-block]').forEach(function (block) {
      var idx = parseInt(block.getAttribute('data-pet-index'), 10) || 1;
      var visible = idx <= qty;
      block.hidden = !visible;
      var nameInput = block.querySelector('[data-kit-pet-name]');
      var photoInput = block.querySelector('[data-kit-pet-photo]');
      if (nameInput) {
        nameInput.disabled = !visible;
        nameInput.required = visible;
      }
      if (photoInput) {
        photoInput.disabled = !visible;
        photoInput.required = visible;
      }
    });
  }

  function setupPetPhotoPreview(input) {
    input.addEventListener('change', function () {
      var block = input.closest('[data-kit-pet-block]') || input.closest('[data-kit-human-photo-block]');
      var previewWrap = block ? block.querySelector('[data-kit-pet-photo-preview], [data-kit-human-photo-preview]') : null;
      var previewImg = block ? block.querySelector('[data-kit-pet-photo-preview-img], [data-kit-human-photo-preview-img]') : null;
      var file = input.files && input.files[0];
      if (!file) {
        if (previewWrap) previewWrap.hidden = true;
        return;
      }
      var maxBytes = 10 * 1024 * 1024;
      if (file.size > maxBytes) {
        alert('La imagen es muy grande. El límite es 10 MB.');
        input.value = '';
        if (previewWrap) previewWrap.hidden = true;
        return;
      }
      var reader = new FileReader();
      reader.onload = function (e) {
        if (previewImg) previewImg.src = e.target.result;
        if (previewWrap) previewWrap.hidden = false;
      };
      reader.readAsDataURL(file);
    });
  }

  // ------------------------------------------------------------------
  // Reconstruye los <select> de estilo / talla / color y la
  // visibilidad de mascotas/humano/color de gorra según el tipo y
  // estilo elegidos para esta pieza.
  // ------------------------------------------------------------------
  function populateSelect(selectEl, values) {
    selectEl.innerHTML = '';
    values.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      selectEl.appendChild(opt);
    });
  }

  // Renderizador genérico de "muestras" circulares de color (radio nativo
  // oculto + círculo de color), reutilizado por color de producto, color
  // de gorra y color de marco — así los tres se ven y se comportan igual.
  function renderSwatches(container, pieceId, namePrefix, dataAttr, colorEntries) {
    container.innerHTML = '';
    colorEntries.forEach(function (c, idx) {
      var label = document.createElement('label');
      label.className = 'custom-options__swatch-option';
      label.setAttribute('data-swatch-tooltip', c.name);

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = namePrefix + '-' + pieceId;
      input.value = c.name;
      input.className = 'custom-options__swatch-input';
      input.setAttribute(dataAttr, '');
      if (idx === 0) input.checked = true;

      var circle = document.createElement('span');
      circle.className = 'custom-options__swatch-circle';
      circle.style.backgroundColor = c.hex;

      label.appendChild(input);
      label.appendChild(circle);
      container.appendChild(label);
    });
  }

  function renderProductColors(pieceEl, colorNames) {
    var container = pieceEl.querySelector('[data-kit-color-swatches]');
    if (!container) return;
    var entries = colorNames.map(function (name) {
      return { name: name, hex: COLOR_HEX_MAP[name] || '#cccccc' };
    });
    renderSwatches(container, pieceEl.getAttribute('data-piece-id'), 'kit-color', 'data-kit-color-input', entries);
  }

  function renderCapColors(pieceEl, capColors) {
    var container = pieceEl.querySelector('[data-kit-cap-color-swatches]');
    if (!container) return;
    renderSwatches(container, pieceEl.getAttribute('data-piece-id'), 'kit-cap-color', 'data-kit-cap-color-input', capColors);
  }

  function renderFrameColors(pieceEl, frameColors) {
    var container = pieceEl.querySelector('[data-kit-frame-color-swatches]');
    if (!container) return;
    renderSwatches(container, pieceEl.getAttribute('data-piece-id'), 'kit-frame-color', 'data-kit-frame-color-input', frameColors);
  }

  // Las píldoras de Estilo son globales (Ilustrado/Bordado) y se
  // renderizan UNA sola vez al crear la pieza: no dependen del tipo de
  // producto, es al revés — el tipo se filtra según el estilo elegido.
  function renderStylePills(pieceEl, root) {
    var container = pieceEl.querySelector('[data-kit-style-pills]');
    if (!container) return;
    container.innerHTML = '';
    STYLE_OPTIONS.forEach(function (opt, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'custom-options__pill';
      btn.setAttribute('data-kit-style-pill', '');
      btn.setAttribute('data-value', opt.key);
      btn.textContent = opt.label;
      if (idx === 0) btn.classList.add('is-selected');
      btn.addEventListener('click', function () {
        container.querySelectorAll('[data-kit-style-pill]').forEach(function (b) {
          b.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');
        onStyleChanged(pieceEl, root);
      });
      container.appendChild(btn);
    });
  }

  // Repuebla el <select> de "Tipo de producto" para que solo muestre los
  // tipos que existen en el estilo actualmente elegido. Si el tipo ya
  // seleccionado sigue existiendo en el nuevo estilo, se conserva;
  // si no, se limpia y la clienta debe volver a elegir.
  function updateTypeOptions(pieceEl, styleKey) {
    var typeSelect = pieceEl.querySelector('[data-kit-type]');
    var currentType = typeSelect.value;
    var availableTypeKeys = STYLE_TO_TYPES[styleKey] || [];
    typeSelect.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = '-- Selecciona --';
    typeSelect.appendChild(placeholder);
    availableTypeKeys.forEach(function (typeKey) {
      var opt = document.createElement('option');
      opt.value = typeKey;
      opt.textContent = PIECE_TYPES[typeKey].label;
      typeSelect.appendChild(opt);
    });
    typeSelect.value = availableTypeKeys.indexOf(currentType) !== -1 ? currentType : '';
  }

  function onStyleChanged(pieceEl, root) {
    updateTypeOptions(pieceEl, getSelectedStyleKey(pieceEl));
    applyStyleDependentFields(pieceEl, root);
  }

  function applyStyleDependentFields(pieceEl, root) {
    var previewBlock = pieceEl.querySelector('[data-kit-piece-preview]');
    var previewImg = pieceEl.querySelector('[data-kit-piece-preview-img]');
    var sizeGroup = pieceEl.querySelector('[data-kit-size-group]');
    var sizeSelect = pieceEl.querySelector('[data-kit-size]');
    var colorGroup = pieceEl.querySelector('[data-kit-color-group]');
    var capColorGroup = pieceEl.querySelector('[data-kit-cap-color-group]');
    var frameColorGroup = pieceEl.querySelector('[data-kit-frame-color-group]');
    var petGroup = pieceEl.querySelector('[data-kit-pet-group]');
    var humanGroup = pieceEl.querySelector('[data-kit-human-group]');
    var humanCheckbox = pieceEl.querySelector('[data-kit-human-checkbox]');
    var humanLabel = pieceEl.querySelector('[data-kit-human-label]');
    var petPriceNote = pieceEl.querySelector('[data-kit-pet-price-note]');

    var ts = getPieceTypeStyle(pieceEl);
    var style = ts ? ts.style : null;

    if (style && style.image && previewBlock && previewImg) {
      previewImg.src = style.image;
      previewImg.alt = ts.type.label + ' (' + ts.style.label + ')';
      previewBlock.style.display = 'flex';
    } else if (previewBlock) {
      previewBlock.style.display = 'none';
      if (previewImg) previewImg.src = '';
    }

    if (style && style.sizes) {
      sizeGroup.hidden = false;
      sizeSelect.required = true;
      populateSelect(sizeSelect, style.sizes);
    } else {
      sizeGroup.hidden = true;
      sizeSelect.required = false;
      sizeSelect.innerHTML = '';
    }

    if (style && style.colors) {
      colorGroup.hidden = false;
      renderProductColors(pieceEl, style.colors);
    } else {
      colorGroup.hidden = true;
    }

    if (style && style.capColors) {
      capColorGroup.hidden = false;
      renderCapColors(pieceEl, style.capColors);
    } else {
      capColorGroup.hidden = true;
    }

    if (style && style.frameColors) {
      frameColorGroup.hidden = false;
      renderFrameColors(pieceEl, style.frameColors);
    } else {
      frameColorGroup.hidden = true;
    }

    if (style) {
      petGroup.hidden = false;
      if (petPriceNote) {
        petPriceNote.textContent = 'Cada mascota adicional en esta pieza: +' + formatMoney(style.pricePerExtraPet, root.getAttribute('data-money-format'));
      }
      updatePetBlocksVisibility(pieceEl);
    } else {
      petGroup.hidden = true;
    }

    if (style && style.humanEnabled) {
      humanGroup.hidden = false;
      if (humanLabel) {
        humanLabel.textContent = '¿Incluir a un humano en esta pieza? (+' + formatMoney(style.humanPrice, root.getAttribute('data-money-format')) + ')';
      }
    } else {
      humanGroup.hidden = true;
      if (humanCheckbox) humanCheckbox.checked = false;
      var humanPhotoBlock = pieceEl.querySelector('[data-kit-human-photo-block]');
      if (humanPhotoBlock) humanPhotoBlock.hidden = true;
    }

    recalcTotal(root);
  }

  // ------------------------------------------------------------------
  // Crea y conecta una nueva tarjeta de pieza a partir del <template>.
  // ------------------------------------------------------------------
  var pieceCounter = 0;

  function createPiece(root) {
    var template = root.parentElement.querySelector('[data-kit-piece-template]') || document.querySelector('[data-kit-piece-template]');
    var fragment = template.content.cloneNode(true);
    var pieceEl = fragment.querySelector('[data-kit-piece]');
    pieceCounter += 1;
    pieceEl.setAttribute('data-piece-id', pieceCounter);

    var typeSelect = pieceEl.querySelector('[data-kit-type]');
    var sizeSelect = pieceEl.querySelector('[data-kit-size]');
    var humanCheckbox = pieceEl.querySelector('[data-kit-human-checkbox]');
    var humanPhotoBlock = pieceEl.querySelector('[data-kit-human-photo-block]');
    var humanPhotoInput = pieceEl.querySelector('[data-kit-human-photo]');
    var removeBtn = pieceEl.querySelector('[data-kit-remove-piece]');

    renderStylePills(pieceEl, root);
    onStyleChanged(pieceEl, root);

    typeSelect.addEventListener('change', function () {
      applyStyleDependentFields(pieceEl, root);
    });
    sizeSelect.addEventListener('change', function () {
      recalcTotal(root);
    });

    pieceEl.querySelectorAll('[data-kit-pet-qty-pill]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        pieceEl.querySelectorAll('[data-kit-pet-qty-pill]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        updatePetBlocksVisibility(pieceEl);
        recalcTotal(root);
      });
    });

    pieceEl.querySelectorAll('[data-kit-pet-photo]').forEach(setupPetPhotoPreview);
    if (humanPhotoInput) setupPetPhotoPreview(humanPhotoInput);

    if (humanCheckbox) {
      humanCheckbox.addEventListener('change', function () {
        if (humanPhotoBlock) {
          humanPhotoBlock.hidden = !humanCheckbox.checked;
          if (humanPhotoInput) {
            humanPhotoInput.disabled = !humanCheckbox.checked;
            humanPhotoInput.required = humanCheckbox.checked;
          }
        }
        recalcTotal(root);
      });
    }

    removeBtn.addEventListener('click', function () {
      removePiece(root, pieceEl);
    });

    var container = root.querySelector('[data-kit-pieces-container]');
    container.appendChild(pieceEl);
    renumberPieces(root);
    updateAddRemoveState(root);
    recalcTotal(root);
    return pieceEl;
  }

  function removePiece(root, pieceEl) {
    var container = root.querySelector('[data-kit-pieces-container]');
    var pieces = container.querySelectorAll('[data-kit-piece]');
    if (pieces.length <= MIN_PIECES) return;
    pieceEl.remove();
    renumberPieces(root);
    updateAddRemoveState(root);
    recalcTotal(root);
  }

  function renumberPieces(root) {
    var pieces = root.querySelectorAll('[data-kit-piece]');
    pieces.forEach(function (pieceEl, idx) {
      var titleEl = pieceEl.querySelector('[data-kit-piece-title]');
      if (titleEl) titleEl.textContent = 'Pieza ' + (idx + 1);
    });
  }

  function updateAddRemoveState(root) {
    var pieces = root.querySelectorAll('[data-kit-piece]');
    var addBtn = root.querySelector('[data-kit-add-piece]');
    if (addBtn) addBtn.disabled = pieces.length >= MAX_PIECES;
    root.querySelectorAll('[data-kit-remove-piece]').forEach(function (btn) {
      btn.disabled = pieces.length <= MIN_PIECES;
    });
  }

  // ------------------------------------------------------------------
  // Método de contacto (una sola vez por kit, no por pieza).
  // ------------------------------------------------------------------
  var CONTACT_FIELD_LABELS = {
    Instagram: 'Tu usuario de Instagram',
    WhatsApp: 'Tu número de WhatsApp',
    'Correo electrónico': 'Tu correo electrónico'
  };

  function setupContactMethod(root) {
    var select = root.querySelector('[data-kit-contact-select]');
    var detail = root.querySelector('[data-kit-contact-detail]');
    var detailLabel = root.querySelector('[data-kit-contact-detail-label]');
    var detailLabelText = root.querySelector('[data-kit-contact-detail-label-text]');
    if (!select || !detail) return;

    function update() {
      var val = select.value;
      if (val) {
        detail.hidden = false;
        detail.disabled = false;
        detail.required = true;
        if (detailLabel) {
          detailLabel.hidden = false;
          if (detailLabelText) detailLabelText.textContent = CONTACT_FIELD_LABELS[val] || 'Tu dato de contacto';
        }
      } else {
        detail.hidden = true;
        detail.disabled = true;
        detail.required = false;
        detail.value = '';
        if (detailLabel) detailLabel.hidden = true;
      }
    }

    select.addEventListener('change', update);
    update();
  }

  // ------------------------------------------------------------------
  // Validación + envío al carrito.
  // ------------------------------------------------------------------
  function showError(root, message) {
    var errEl = root.querySelector('[data-custom-options-error]');
    if (errEl) errEl.textContent = message;
  }

  function clearError(root) {
    var errEl = root.querySelector('[data-custom-options-error]');
    if (errEl) errEl.textContent = '';
  }

  function findFirstInvalidField(root) {
    var candidates = root.querySelectorAll('[required]:not([disabled])');
    for (var i = 0; i < candidates.length; i++) {
      var field = candidates[i];
      if (field.type === 'file') {
        if (!field.files || field.files.length === 0) return field;
        continue;
      }
      if (field.value === undefined || field.value === null || String(field.value).trim() === '') {
        return field;
      }
    }
    // Radios de color de producto (playera/sudadera): al menos uno marcado
    // por pieza que los tenga.
    var colorGroups = root.querySelectorAll('[data-kit-color-group]');
    for (var c = 0; c < colorGroups.length; c++) {
      var colorGroupEl = colorGroups[c];
      if (colorGroupEl.hidden) continue;
      var colorChecked = colorGroupEl.querySelector('[data-kit-color-input]:checked');
      if (!colorChecked) return colorGroupEl;
    }
    // Radios de color de gorra: al menos uno marcado por pieza que los tenga.
    var capGroups = root.querySelectorAll('[data-kit-cap-color-group]');
    for (var j = 0; j < capGroups.length; j++) {
      var group = capGroups[j];
      if (group.hidden) continue;
      var checked = group.querySelector('[data-kit-cap-color-input]:checked');
      if (!checked) return group;
    }
    // Radios de color de marco: al menos uno marcado por pieza que los tenga.
    var frameGroups = root.querySelectorAll('[data-kit-frame-color-group]');
    for (var f = 0; f < frameGroups.length; f++) {
      var frameGroup = frameGroups[f];
      if (frameGroup.hidden) continue;
      var frameChecked = frameGroup.querySelector('[data-kit-frame-color-input]:checked');
      if (!frameChecked) return frameGroup;
    }
    // Píldoras de estilo: al menos una seleccionada por pieza que las tenga.
    var styleGroups = root.querySelectorAll('[data-kit-style-group]');
    for (var k = 0; k < styleGroups.length; k++) {
      var styleGroup = styleGroups[k];
      if (styleGroup.hidden) continue;
      var selectedStyle = styleGroup.querySelector('[data-kit-style-pill].is-selected');
      if (!selectedStyle) return styleGroup;
    }
    return null;
  }

  function pieceVariantKey(ts, sizeVal, colorVal) {
    if (ts.style.variantKeyOrder === 'color-size') return colorVal + ' / ' + sizeVal;
    if (ts.style.variantKeyOrder === 'size-color') return sizeVal + ' / ' + colorVal;
    return 'Default Title';
  }

  function collectPieceData(pieceEl) {
    var ts = getPieceTypeStyle(pieceEl);
    if (!ts) return null;

    var sizeSelect = pieceEl.querySelector('[data-kit-size]');
    var sizeVal = sizeSelect && !pieceEl.querySelector('[data-kit-size-group]').hidden ? sizeSelect.value : null;
    var colorInput = pieceEl.querySelector('[data-kit-color-input]:checked');
    var colorVal = colorInput && !pieceEl.querySelector('[data-kit-color-group]').hidden ? colorInput.value : null;

    var variantKey = sizeVal && colorVal ? pieceVariantKey(ts, sizeVal, colorVal) : 'Default Title';
    var variantId = ts.style.variants[variantKey];

    var capColorInput = pieceEl.querySelector('[data-kit-cap-color-input]:checked');
    var capColor = capColorInput ? capColorInput.value : null;

    var frameColorInput = pieceEl.querySelector('[data-kit-frame-color-input]:checked');
    var frameColor = frameColorInput ? frameColorInput.value : null;

    var petQty = getPetQty(pieceEl);
    var pets = [];
    pieceEl.querySelectorAll('[data-kit-pet-block]').forEach(function (block) {
      var idx = parseInt(block.getAttribute('data-pet-index'), 10) || 1;
      if (idx > petQty) return;
      var nameInput = block.querySelector('[data-kit-pet-name]');
      var photoInput = block.querySelector('[data-kit-pet-photo]');
      pets.push({
        index: idx,
        name: nameInput ? nameInput.value : '',
        file: photoInput && photoInput.files ? photoInput.files[0] : null
      });
    });

    var humanCheckbox = pieceEl.querySelector('[data-kit-human-checkbox]');
    var humanIncluded = !!(ts.style.humanEnabled && humanCheckbox && humanCheckbox.checked);
    var humanPhotoInput = pieceEl.querySelector('[data-kit-human-photo]');

    var extraPets = petQty - 1;
    var surcharge = extraPets * ts.style.pricePerExtraPet + (humanIncluded ? ts.style.humanPrice : 0);

    return {
      typeLabel: ts.type.label,
      styleLabel: ts.style.label,
      productId: ts.style.productId,
      variantId: variantId,
      size: sizeVal,
      color: colorVal,
      capColor: capColor,
      frameColor: frameColor,
      pets: pets,
      humanIncluded: humanIncluded,
      humanFile: humanIncluded && humanPhotoInput ? humanPhotoInput.files[0] : null,
      surcharge: surcharge
    };
  }

  async function addPieceToCart(pieceData, groupId, contactMethod, contactDetail) {
    if (!pieceData.variantId) {
      throw new Error(
        'No se encontró la variante para ' + pieceData.typeLabel + ' (' + pieceData.styleLabel + ', ' + pieceData.size + ' / ' + pieceData.color + ').'
      );
    }

    var formData = new FormData();
    formData.append('id', pieceData.variantId);
    formData.append('quantity', 1);
    formData.append('properties[_grupo_kit]', groupId);
    formData.append('properties[Método de contacto]', contactMethod);
    formData.append('properties[Dato de contacto]', contactDetail);

    // Propiedad explícita con la cantidad de mascotas de esta pieza, para
    // que se vea de un vistazo en el carrito y en el checkout.
    if (pieceData.pets.length > 0) {
      formData.append('properties[Cantidad de mascotas]', String(pieceData.pets.length));
    }

    pieceData.pets.forEach(function (pet) {
      formData.append('properties[Mascota ' + pet.index + ' - Nombre]', pet.name);
      if (pet.file) formData.append('properties[Mascota ' + pet.index + ' - Foto]', pet.file);
    });

    if (pieceData.capColor) {
      formData.append('properties[Color de la gorra]', pieceData.capColor);
    }

    if (pieceData.frameColor) {
      formData.append('properties[Color del marco]', pieceData.frameColor);
    }

    if (pieceData.humanIncluded) {
      formData.append('properties[¿Incluir humano?]', 'Sí');
      if (pieceData.humanFile) formData.append('properties[Foto del humano]', pieceData.humanFile);
    }

    var res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    });

    if (!res.ok) {
      var errData = await res.json().catch(function () {
        return {};
      });
      throw new Error(errData.description || 'No se pudo agregar ' + pieceData.typeLabel + ' al carrito.');
    }
    return res.json();
  }

  async function addSurchargeToCart(amount, groupId, forLabel) {
    var addonVariantId = ADDON_VARIANT_MAP[amount];
    if (!addonVariantId) {
      throw new Error('No hay un ID de variante configurado para el recargo de $' + amount + ' (' + forLabel + ').');
    }
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: addonVariantId,
            quantity: 1,
            properties: { _grupo_kit: groupId, _para_pieza: forLabel }
          }
        ]
      })
    });
    if (!res.ok) {
      console.error('[kit-builder] Error al agregar el cargo adicional de ' + forLabel + '.');
    }
  }

  function resetSubmitButton(btn) {
    if (btn) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-original-text') || btn.textContent;
    }
  }

  async function handleSubmit(root) {
    clearError(root);

    var invalidField = findFirstInvalidField(root);
    if (invalidField) {
      if (typeof invalidField.scrollIntoView === 'function') {
        invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (typeof invalidField.focus === 'function') invalidField.focus();
      showError(root, 'Por favor completa todas las opciones obligatorias antes de continuar.');
      return;
    }

    var pieces = root.querySelectorAll('[data-kit-piece]');
    var piecesData = [];
    for (var i = 0; i < pieces.length; i++) {
      var data = collectPieceData(pieces[i]);
      if (!data) {
        showError(root, 'Falta terminar de configurar una de las piezas.');
        return;
      }
      piecesData.push(data);
    }

    var contactMethod = root.querySelector('[data-kit-contact-select]').value;
    var contactDetail = root.querySelector('[data-kit-contact-detail]').value;

    var submitBtn = root.querySelector('[data-kit-submit]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('data-original-text', submitBtn.textContent);
      submitBtn.textContent = 'Agregando tu kit...';
    }

    var groupId = 'kit-' + Date.now() + '-' + Math.floor(Math.random() * 10000);

    try {
      for (var p = 0; p < piecesData.length; p++) {
        var piece = piecesData[p];
        var label = piece.typeLabel + ' (' + piece.styleLabel + ')';
        await addPieceToCart(piece, groupId, contactMethod, contactDetail);
        if (piece.surcharge > 0) {
          await addSurchargeToCart(piece.surcharge, groupId, label);
        }
      }

      if (AFTER_ADD_BEHAVIOR === 'redirect') {
        window.location.href = '/cart';
      } else {
        resetSubmitButton(submitBtn);
      }
    } catch (err) {
      console.error('[kit-builder]', err);
      showError(root, err.message || 'Ocurrió un error al agregar tu kit. Intenta de nuevo.');
      resetSubmitButton(submitBtn);
    }
  }

  // ------------------------------------------------------------------
  // Inicialización.
  // ------------------------------------------------------------------
  function initKitBuilder(root) {
    setupContactMethod(root);

    for (var i = 0; i < MIN_PIECES; i++) {
      createPiece(root);
    }

    var addBtn = root.querySelector('[data-kit-add-piece]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var container = root.querySelector('[data-kit-pieces-container]');
        if (container.querySelectorAll('[data-kit-piece]').length >= MAX_PIECES) return;
        createPiece(root);
      });
    }

    var submitBtn = root.querySelector('[data-kit-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        handleSubmit(root);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-kit-builder]').forEach(initKitBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
